export function uniqueAndDefinedGrades<T>(
	value: T,
	index: number,
	self: T[],
): boolean {
	return (
		value !== undefined && value !== null && self.indexOf(value) === index
	);
}
